module.exports = __webpack_public_path__ + "static/media/unico_materiais_const_novo.6a174c5a.png";